import FirebaseHandler from "./index";
import { httpsCallable } from "firebase/functions";
export var subscribeToNewsletter = function subscribeToNewsletter(email) {
    var subscribeNewsletter = httpsCallable(FirebaseHandler.functions, "subscribeNewsletter");
    return subscribeNewsletter({
        email: email
    });
};
